import React, { Component } from "react";
import FlexView from "react-flexview";
import * as R from "ramda";
import SimpleDate from "./SimpleDate";

class SimpleDateRange extends Component {
    getDataValue(fieldName) {
        return !R.isNil(this.props.data) && this.props.data[fieldName]
            ? this.props.data[fieldName]
            : null;
    }

    render() {
        return (
            <FlexView column vAlignContent="center">
                <div className="txt-site txt-11 txt-main txt-bold">
                    <h4>{this.props.label}:</h4>
                </div>
                <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                    <SimpleDate
                        id={`select_date_${this.props.startDateName}`}
                        name={this.props.startDateName}
                        nextdate
                        date={this.getDataValue(this.props.startDateName)}
                        maxDate={this.getDataValue(this.props.endDateName)}
                        onChange={(value) => this.props.onStartDateChange(this.props.startDateName, value)}
                    />
                    <span className="margin-bottom-20px">To</span>
                    <SimpleDate
                        id={`select_date_${this.props.endDateName}`}
                        name={this.props.endDateName}
                        nextdate
                        date={this.getDataValue(this.props.endDateName)}
                        onChange={(value) => this.props.onEndDateChange(this.props.endDateName, value)}
                    />
                </FlexView>
            </FlexView>
        );
    }
}

export default SimpleDateRange;
